import "@hotwired/turbo-rails"

// --- Bootstrap ---
import "bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"

// --- DataTables (Bootstrap 5 build) ---
import DataTable from "datatables.net-bs5"                 // styled constructor
import "datatables.net-bs5/css/dataTables.bootstrap5.css"  // DT CSS

// --- Your app CSS (migrated) ---
import "./styles/trader8.css"

// --- Debug: prove the bundle + DT are loaded ---
console.log("[APP] application.js loaded")
console.log("[DT] typeof DataTable =", typeof DataTable)

// --- Init a specific table by id (deterministic, easy to debug) ---
// function initTradesTable() {
//   const el = document.getElementById("trades_table")
//   if (!el) { console.log("[DT] #trades_table not found") ; return }
//   if (el._dt) { console.log("[DT] already initialised") ; return }

//   console.log("[DT] init #trades_table")

//   el._dt = new DataTable(el, {
//     pageLength: 25,
//     lengthMenu: [10, 25, 50, 100],
//     ordering: true,
//     order: [[0, "desc"]], // default: newest open date first
//     stateSave: true,
//     layout: { topStart: "search", topEnd: "pageLength", bottomStart: "info", bottomEnd: "paging" },
//     columnDefs: [
//       { orderable: false, targets: [-1] }, // last column (Actions)
//     ],
//   })
// }

function initDataTables(eventOrRoot = document) {
  const root =
    eventOrRoot instanceof Event
    ? (eventOrRoot.target || document)
    : eventOrRoot
  
  // In some cases target might be <html> etc; document is safest
  const scope = root?.querySelectorAll ? root : document

  const tables = root.querySelectorAll("table[data-controller='datatable']");
  tables.forEach((el) => {
    if (el._dt) return; // prevent double init on Turbo visits

    const preserveServerOrder = el.dataset.preserveServerOrder === "true"

    el._dt = new DataTable(el, {
      // ---- core UX ----
      pageLength: 25,
      lengthMenu: [10, 25, 50, 100],
      ordering: true,
      order: preserveServerOrder ? [] : [[0, "desc"]],
      stateSave: !preserveServerOrder,
      layout: {
        topStart: "search",
        topEnd: "pageLength",
        bottomStart: "info",
        bottomEnd: "paging"
      },
      columnDefs: Array.from(el.querySelectorAll("thead th")).flatMap((th, index) =>
        th.dataset.orderable === "false" ? [{ orderable: false, targets: [index] }] : []
      ),

      // Optional if you installed Responsive:
      // responsive: true
    })

  });
}

// Fire on initial full page load and on Turbo visits
document.addEventListener("DOMContentLoaded", initDataTables)
document.addEventListener("turbo:load", initDataTables)

// Clean up before Turbo caches the page
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("table[data-controller='datatable']").forEach((el) => {
    if (el._dt) { el._dt.destroy(true); el._dt = null; }
  });
});